// extracted by mini-css-extract-plugin
export default {"docs":"Docs_docs__gJhrT","title":"Docs_title__4RC2c","headingText":"Docs_headingText__Vcy4F"};